module.exports = __webpack_public_path__ + "static/media/satellite.affa4e7c.svg";